import api from "../api";
import {useSessionStore} from "~/storage/session";

export default defineNuxtRouteMiddleware(  (to, next) => {
    const sessionStore = useSessionStore();
    let intentUrl = next.path
    if (next.query !== undefined) {
        const urlParams = new URLSearchParams(next.query).toString();

        intentUrl = `${next.path}?${urlParams}`
    }

    sessionStore.setIntentUrl(intentUrl)
    if (to.path === '/') {
        //return
    }
    api.Auth.getCSRFToken()
    api.User.getUserInfo().then((userData)=>{
        const sessionStore = useSessionStore()
        sessionStore.setLoggedIn(true);
        sessionStore.setUser(userData.data);
    }).catch(()=>{})
})